import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";

export class SortTransportCommand extends IRequestCommand<
  ISortTransportResponse,
  ErrorDetails,
  Array<any>
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/sortTransports';
  public override setParameters(parameters: Array<any>) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.pop()
    );
    this._commandBody = parameters;
  }
}

/*export interface ISortTransportCommandParameters
  extends Array<any>,
    ICommandParameters {

}*/

export interface ISortTransportResponse extends ICommandResponse {}
